import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { IGetPatientPregnanciesParams, IPregnancy } from '~/interfaces'
import { fetchPatientPregnancies, message } from '~/services'

const UNIQUE_KEY = 'patient-pregnancies'

export const useFetchPatientPregnancies = (
  fetchParams: IGetPatientPregnanciesParams | null
): UseQueryResult<IPregnancy[], Error> => {
  const fetcher = async () => {
    if (!fetchParams) throw new Error('fetchParams is required')
    try {
      const response = await fetchPatientPregnancies(fetchParams)

      if (response.length <= 0) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw message('maternalInfant.empty_modal_section')
      }

      return response
    } catch (error) {
      if (typeof error === 'string') throw new Error(error)
      throw new Error(message('messages.genericUnexpectedError'))
    }
  }

  return useQuery<IPregnancy[], Error>([UNIQUE_KEY, fetchParams], fetcher, {
    enabled: !!fetchParams,
    cacheTime: Infinity,
    staleTime: Infinity
  })
}
